import styled, { css } from 'styled-components'
import { colors, fonts } from 'client/styles'

export const CheckboxBase = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-block-end: 0.8em;
  user-select: none;

  > svg {
    border-radius: 3px;
    border: 2px solid;
    flex: 0 0 auto;
    height: 20px;
    vertical-align: bottom;
    width: 20px;

    ${props =>
      props.isChecked
        ? `
            background-color: ${colors.magenta};
            border-color: ${colors.magenta};
            fill: ${colors.white};
          `
        : `
            background-color: ${colors.white};
            border-color: ${colors.grey4};
            fill: ${colors.white};
          `}
  }

  ${props => props.isFocused && `svg { border-color: ${colors.grey2}; }`}

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
`

export const Text = styled.span`
  color: ${colors.grey2};
  display: inline-block;
  font-family: ${fonts.default};
  font-size: ${props => (props.size ? `${props.size}px` : '16px')};
  line-height: 1.7em;
  margin-inline-start: 14px;
  vertical-align: middle;

  a,
  a:active {
    color: ${colors.blue};
    text-decoration: none;
    text-transform: lowercase;
  }

  ${props =>
    props.asterisk &&
    css`
      :after {
        content: '*';
        color: ${colors.magenta};
        margin-inline-start: 5px;
      }
    `}
`
